import { render, staticRenderFns } from "./faxian.vue?vue&type=template&id=34ed44c8&scoped=true"
import script from "./faxian.vue?vue&type=script&lang=js"
export * from "./faxian.vue?vue&type=script&lang=js"
import style0 from "./faxian.vue?vue&type=style&index=0&id=34ed44c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed44c8",
  null
  
)

export default component.exports